import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import clients, { getClientById } from './clients';
import { AUTH_TOKEN } from './clients/constants';
import resolveRecipe from './clients/resolveRecipe';
import ClientRail from './components/ClientRail';
import ClientRecipe from './components/ClientRecipe';
import Layout from './styled';

const ClientConfiguration = ({ mcpServerUrl = 'https://mcp.apps.faradaysec.com/mcp' }) => {
  const [selectedClientId, setSelectedClientId] = useState(clients[0].id);
  const [preferredAuthMethod, setPreferredAuthMethod] = useState(AUTH_TOKEN);

  /* Secrets live here and nowhere else: never in Redux, which persists to
     sessionStorage, and never in a request. */
  const [credentials, setCredentials] = useState({
    instanceUrl: window.location.origin,
    apiToken: '',
    username: '',
    password: ''
  });

  const handleCredentialChange = (name, value) => setCredentials(
    (current) => ({ ...current, [name]: value })
  );

  const client = getClientById(selectedClientId);
  const { authMethods } = client;

  const authMethod = authMethods.includes(preferredAuthMethod)
    ? preferredAuthMethod
    : (authMethods[0] || null);

  const builtSections = useMemo(
    () => client.buildSections({ authMethod }),
    [client, authMethod]
  );

  const sections = useMemo(() => {
    const values = {
      serverUrl: mcpServerUrl,
      instanceUrl: credentials.instanceUrl.trim(),
      apiToken: credentials.apiToken.trim(),
      username: credentials.username.trim(),
      password: credentials.password.trim()
    };

    return resolveRecipe(builtSections, values)
      .map((section) => ({
        ...section,
        blocks: section.blocks.filter(({ hiddenForAuthMethod }) => hiddenForAuthMethod !== authMethod)
      }))
      .filter(({ blocks }) => blocks.length > 0);
  }, [builtSections, mcpServerUrl, credentials, authMethod]);

  return (
    <Layout>
      <ClientRail
        clients={ clients }
        onChange={ setSelectedClientId }
        value={ selectedClientId }
      />
      <ClientRecipe
        authMethod={ authMethod }
        client={ client }
        credentials={ credentials }
        messageValues={ { serverUrl: mcpServerUrl } }
        onAuthMethodChange={ setPreferredAuthMethod }
        onCredentialChange={ handleCredentialChange }
        onSelectClient={ setSelectedClientId }
        sections={ sections }
      />
    </Layout>
  );
};

ClientConfiguration.propTypes = {
  mcpServerUrl: PropTypes.string
};

export default ClientConfiguration;
